import clsx from 'clsx';
import { FC, useState } from 'react';
import Category from '../../assets/header/category.jpg';
import Guide from '../../assets/header/guide.jpg';
import Scene from '../../assets/header/scene.jpg';
import { ReactComponent as CursorRight } from '../../assets/icon/cursor_right.svg';
import { mainCategories } from '../../constants/Categories';
import { GuideMenu as GuideMenuItems } from '../../constants/Menu';
import { scenes } from '../../constants/Scenes';
import { Link } from '../Link.client';

export const DesktopNavigation = () => {
  const [menu, setMenu] = useState<string>();

  return (
    <nav className="relative border-t border-lightGray py-2">
      <div className="wrapper text-[15px] font-semibold">
        <ul className="flex justify-center">
          <li>
            <Link
              route="categories"
              className={clsx(
                'border-b-4 py-2 px-7',
                menu === 'category' ? 'border-accent' : 'border-transparent',
              )}
              onMouseEnter={() => setMenu('category')}
              onMouseLeave={() => setMenu(undefined)}
            >
              カテゴリーから探す
            </Link>
          </li>
          <li>
            <Link
              route="scenes"
              className={clsx(
                'border-b-4 py-2 px-7',
                menu === 'scene' ? 'border-accent' : 'border-transparent',
              )}
              onMouseEnter={() => setMenu('scene')}
              onMouseLeave={() => setMenu(undefined)}
            >
              シーンから探す
            </Link>
          </li>
          {/* <li>
            <Link route="categories" className="px-7">
              写真・名入れグッズ
            </Link>
          </li> */}
          <li>
            <Link route="features" className="px-7">
              特集
            </Link>
          </li>
          <li>
            <Link route="ranking" className="px-7">
              ランキング
            </Link>
          </li>
          <li>
            <Link
              route="guides"
              className={clsx(
                'border-b-4 py-2 px-7',
                menu === 'guide' ? 'border-accent' : 'border-transparent',
              )}
              onMouseEnter={() => setMenu('guide')}
              onMouseLeave={() => setMenu(undefined)}
            >
              ご利用ガイド
            </Link>
          </li>
        </ul>
      </div>
      {menu === 'category' && (
        <div onMouseEnter={() => setMenu('category')} onMouseLeave={() => setMenu(undefined)}>
          <CategoryMenu />
        </div>
      )}
      {menu === 'scene' && (
        <div onMouseEnter={() => setMenu('scene')} onMouseLeave={() => setMenu(undefined)}>
          <SceneMenu />
        </div>
      )}
      {menu === 'guide' && (
        <div onMouseEnter={() => setMenu('guide')} onMouseLeave={() => setMenu(undefined)}>
          <GuideMenu />
        </div>
      )}
    </nav>
  );
};

const CategoryMenu: FC = () => (
  <div className="absolute left-0 right-0 top-[38px] w-screen bg-attention py-8">
    <div className="wrapper flex flex-row justify-between">
      <div className="basis-2/3">
        <ul className="grid grid-cols-3 gap-y-4">
          {mainCategories.map((category, i) => (
            <li key={i}>
              <Link route="category" handle={category} className="flex items-center">
                <CursorRight className="mr-2 w-3 fill-gray" />
                <p className="text-sm font-normal text-gray">{category}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <Link route="category" handle="ペット仏壇">
        <div className="max-w-[300px] basis-1/3">
          <img src={Category} alt="バナー" className="object-cover" />
          <p className="mt-2 text-xs font-normal text-gray">
            可愛いデザインの仏壇や、インテリアにマッチするシンプルな仏壇までそろっています。
          </p>
        </div>
      </Link>
    </div>
  </div>
);

const SceneMenu: FC = () => (
  <div className="absolute left-0 right-0 top-[38px] w-screen bg-attention py-8">
    <div className="wrapper flex flex-row justify-between">
      <div className="basis-2/3">
        <ul className="grid grid-cols-3 gap-y-4">
          {scenes.map((scene, i) => (
            <li key={i}>
              <Link route="scene" handle={scene} className="flex items-center">
                <CursorRight className="mr-2 w-3 fill-gray" />
                <p className="text-sm font-normal text-gray">{scene}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <Link route="scene" handle="いつでも一緒に持ち歩き">
        <div className="max-w-[300px] basis-1/3">
          <img src={Scene} alt="バナー" className="object-cover" />
          <p className="mt-2 text-xs font-normal text-gray">
            いつも一緒にいられるネックレスやキーホルダータイプの遺骨カプセルがおすすめです。
          </p>
        </div>
      </Link>
    </div>
  </div>
);

const GuideMenu: FC = () => (
  <div className="absolute left-0 right-0 top-[38px] w-screen bg-attention py-8">
    <div className="wrapper flex flex-row justify-between">
      <div className="basis-2/3">
        <ul className="grid grid-cols-3 gap-y-4">
          {GuideMenuItems.map((item, i) => (
            <li key={i}>
              <Link {...item.route} className="flex items-center">
                <CursorRight className="mr-2 w-3 fill-gray" />
                <p className="text-sm font-normal text-gray">{item.title}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <Link route="guides">
        <div className="max-w-[300px] basis-1/3">
          <img src={Guide} alt="バナー" className="object-cover" />
          <p className="mt-2 text-xs font-normal text-gray">
            ご配送・お支払い・返品など、お客様をサポートする各種情報や方法をご案内。
          </p>
        </div>
      </Link>
    </div>
  </div>
);
